import { i18n } from '../main'

export default function (value) {
  return value === 0 ? i18n.t('entrant') : `${value} év`
}



// WEBPACK FOOTER //
// ./src/filters/experience.js